module.exports = __webpack_public_path__ + "img/2.2-Pivot-Values-Count.4ced6d3f.png";